(function pragmaOnce() {
  if (window.__isESlideManagerVendorsBundleLoaded__) {
    throw new Error('Attempted to load the eSM vendors bundle more than once. This can happen if HeaderInclude("SpectrumMin") is included in an Ajax callback and will cause unexpected behaviors. Check your setup!');
  }
  window.__isESlideManagerVendorsBundleLoaded__ = true;
}());
